import { CheckOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { Fragment, h } from "preact";
import { IColumn } from "../interface/table";
import { color } from "../../../resources";
import { IconButton } from "../../../components/button/icon";
import { Text } from "../../../components/text";
import { convertStrRepair, getPropertiesStatus } from "../../../functions";
import { Center } from "../../../style/styled";
import { TagCompoent } from "../../../components/tag/styled";
import { createColumnTextSearch } from "../../../components/table/column";
// import { IStateMaintenances } from "../interface/statemaintenances";

export const COULMN_DATA = (props?: any): IColumn[] => [
  createColumnTextSearch("ลำดับ", "index", {}),
  createColumnTextSearch("รหัสคำขอ", "requestNo", { width: "8em" }),
  createColumnTextSearch("รหัสการซ่อม", "maintainId", {
    width: "10em",
    render: (text: any) => {
      return <Text size={"S"} text={text as string} bold={true} />;
    },
  }),
  createColumnTextSearch("หมายเลขเครื่องตัด", "deviceId", { width: "6em" }),
  {
    title: "version เครื่องตัด",
    dataIndex: "versionMachine",
    key: "versionMachine",
    width: "10em",
  },
  createColumnTextSearch("รหัสลูกค้า", "customerCode", { width: "10em" }),
  createColumnTextSearch("ชื่อลูกค้า", "customerName", {
    width: "14em",
    align: "left",
  }),
  {
    title: "วันที่แจ้ง",
    dataIndex: "createDate",
    key: "createDate",
    width: "12em",
  },
  createColumnTextSearch("รหัสเซลล์", "saleCode", { width: "6em" }),
  createColumnTextSearch("ผู้ที่แจ้ง", "userCreate", { width: "6em" }),
  createColumnTextSearch("รายละเอียด", "description", {
    width: "20em",
    align: "left",
  }),
  {
    title: "วันที่ซ่อมเสร็จ",
    dataIndex: "repairCompleteDate",
    key: "repairCompleteDate",
    width: "12em",
  },
  createColumnTextSearch("ช่างที่ซ่อม", "repairman", { width: "8em" }),
  {
    title: "วันที่กรอก Tracking",
    dataIndex: "trackingDate",
    key: "trackingDate",
    width: "12em",
  },
  createColumnTextSearch("ประเภท Tracking", "deliveryName", { width: "10em" }),
  createColumnTextSearch("หมายเลข Tracking", "trackingNo", { width: "10em" }),
  createColumnTextSearch("คนที่กรอก Tracking", "trackingBy", { width: "12em" }),
  {
    title: "ซ่อม / เคลม",
    dataIndex: "maintainType",
    key: "maintainType",
    width: "8em",
    fixed: "right",
    render: (text) => {
      const t = convertStrRepair(text as string);
      return (
        <>
          <Text
            size={"S"}
            text={t}
            bold={true}
            color={
              t === "เปลี่ยน" ? color.btn_primary : color.btn_hover_primary
            }
          />
        </>
      );
    },
    filters: [
      {
        text: "ซ่อม",
        value: "ซ่อม",
      },
      {
        text: "เปลี่ยน",
        value: "เปลี่ยน",
      },
      {
        text: "ซ่อม - มีแสปร์",
        value: "ซ่อม - มีแสปร์",
      },
    ],
    onFilter: (value: string, record: any) => {
      const t = convertStrRepair(record.maintainType as string);
      return t === value;
    },
  },
  {
    title: "สถานะ",
    dataIndex: "maintainStatus",
    key: "maintainStatus",
    width: "10em",
    fixed: "right",
    render: (text, r) => {
      const { color: c } = getPropertiesStatus(r.maintainStatusId as string);
      return (
        <Center>
          <TagCompoent color={c}>{text as string}</TagCompoent>
        </Center>
      );
    },
  },
  {
    title: "",
    key: "button",
    width: "10em",
    fixed: "right",
    render: (record: any) => {
      const _disabled = record.maintainStatusId === "STPH-100";
      return (
        <>
          <Button
            danger
            type="primary"
            shape="circle"
            onClick={() => props.onDelete(record)}
            icon={(<DeleteOutlined />) as React.ReactNode}
            style={{ marginRight: 10 }}
            disabled={_disabled}
          />

          <Button
            type="primary"
            shape="circle"
            onClick={() => props.onEdit(record)}
            icon={(<EditOutlined />) as React.ReactNode}
            style={{ marginRight: 10 }}
          />

          <IconButton
            onClick={() => props.onOpenModal(record)}
            shape="circle"
            type="primary"
            icon={
              (
                <CheckOutlined
                  style={{ color: !_disabled ? "#FFFFFF" : color.overlay }}
                />
              ) as React.ReactNode
            }
            color={color.green}
            hover={!_disabled}
            disabled={_disabled}
          />
        </>
      );
    },
  },
];
